// Editable promotional content — owner updates this file to change the promo.

export const promotions = [
  {
    id: "summer-braid-special",
    active: true,
    kicker: "Summer Braid Special",
    title: "Feed-In Braids",
    price: "$100",
    priceNote: "All hair included",
    features: ["Neat", "Lightweight", "Protective", "Long Lasting"],
    cta: "Book This Style",
    serviceId: "feed-in-braids",
    image: "/assets/gallery/g-feedin-2.jpg",
  },
];

export const activePromo = promotions.find((p) => p.active);

